var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-column',[_c('vca-dropdown',{attrs:{"taggable":true,"multiple":false,"options":_vm.artistList,"label":"","placeholder":_vm.$t('events.artist.placeholder')},model:{value:(_vm.artists),callback:function ($$v) {_vm.artists=$$v},expression:"artists"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }